import { Flex, Text } from "@chakra-ui/react";
import type {
  APIListingAgentUpdateEntry,
  APIListingApplicantFeedbackEntry,
  APIListingEventFeedbackEntry,
} from "models/types/api-listing";
import CommentIcon from "assets/icons/medium/comment.svg?react";
import DollarIcon from "assets/icons/medium/dollar.svg?react";
import { FeedbackHeader } from "modules/vendor-portal/screens/overview/components/feedback/feedback-header";
import { FeedbackIcon } from "modules/vendor-portal/screens/overview/components/feedback/feedback-icon";
import { FeedbackListItemFooter } from "modules/vendor-portal/screens/overview/components/feedback/footer/feedback-list-item-footer";

type FeedbackListItemProps = {
  feedback:
    | APIListingApplicantFeedbackEntry
    | APIListingAgentUpdateEntry
    | APIListingEventFeedbackEntry;
};

export function FeedbackListItem({ feedback }: FeedbackListItemProps) {
  return (
    <Flex direction={"row"} gap={2} justify={"flex-start"}>
      <FeedbackIcon
        icon={
          ["price_reduction", "offer"].includes(feedback.type.id)
            ? DollarIcon
            : CommentIcon
        }
      />

      <Flex direction={"column"} gap={2} flex={1}>
        <FeedbackHeader feedback={feedback} />
        <Flex direction={"column"} gap={3}>
          <Text textStyle={"large"} whiteSpace={"pre-line"} color={"gray.600"}>
            {feedback.note ||
              `No written feedback provided. ${
                feedback.type.id === "enquiry"
                  ? "Included in total enquiry count."
                  : ""
              }`}
          </Text>
          <FeedbackListItemFooter feedback={feedback} />
        </Flex>
      </Flex>
    </Flex>
  );
}
